<template>
  <div v-if="this.GET_ACCOUNT_DATA.group_id == 1">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t("project.general_settings") }}</h3>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.project_name") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.project_name')"
                v-model="project_name"
              />
            </div>
          </div>
          <!-- <div class="col-xs-4">
            <div class="form-group">
              <label>{{$t('project.project_id')}}</label>
              <input type="text" class="form-control" :placeholder="$t('project.project_id')" v-model="project_id">
            </div>
          </div>-->
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.project_code") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.project_code')"
                v-model="project_code"
                :disabled="GET_ACCOUNT_DATA.id !== 1"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.project_owner") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.project_owner')"
                v-model="project_owner"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.project_start_date") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.project_start_date')"
                v-model="project_start_date"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.project_status") }}</label>
              <select
                v-model="project_status"
                class="form-control"
                id="privilege"
              >
                <option
                  v-for="project_status in project_status_list"
                  v-bind:value="project_status.id"
                  :key="project_status.id"
                  >{{ $t(project_status.text) }}</option
                >
              </select>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.operator_name") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.operator_name')"
                v-model="operator_name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.operator_telephone") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.operator_telephone')"
                v-model="operator_telephone"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.operator_website") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.operator_website')"
                v-model="operator_website"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.customerCarePhoneNumber") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.customerCarePhoneNumber')"
                v-model="customerCarePhoneNumber"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.managingDirector") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.managingDirector')"
                v-model="managingDirector"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.companyName") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.companyName')"
                v-model="companyName"
              />
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>{{ $t("project.taxIdentificationNumber") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.taxIdentificationNumber')"
                v-model="taxIdentificationNumber"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project.operator_address") }}</label>
              <input
                type="text"
                class="form-control"
                :placeholder="$t('project.operator_address')"
                v-model="operator_address"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>{{ $t("project.project_description") }}</label>
              <textarea
                class="form-control"
                rows="3"
                :placeholder="$t('project.project_description')"
                v-model="project_description"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- logo img -->

        <div class="row">
          <logo-crop
            @project_logo="GetProjectLogo"
            :file="uploadFile"
            ref="logoCrop"
          />
          <div class="col-xs-12 col-md-12 col-lg-12" style="display:flex; align-items: center;">
            <div class="col-xs-12 col-md-6" style="display:flex; align-items: center;">
              <div
                class="col-xs-6 logo-lg"
                style="display:flex; justify-content:center;align-items: center;"
              >
                <img
                  v-if="project_logo == null"
                  :src="img_url.img_default_project"
                  class="resize-img-lg"
                />
                <img v-else class="resize-img-lg" :src="project_logo" />
              </div>
              <div class="col-xs-6">
                <div class="form-group">
                  <label>{{ $t("project.project_logo") }}</label>
                </div>
                <button v-if="project_logo === null" @click="triggerInputUploadLogo" style="width:100px;">
                  Upload
                </button>
                <button v-else @click="project_logo = null" class="btn btn-danger" style="width:100px;">
                  <i class="fa fa-trash"></i>
                  {{ $t('project.removeLogo') }}
                </button>
              </div>
            </div>
            <div class="col-xs-12 col-md-6" style="display:flex; align-items: center;">
              <div
                class="col-xs-4  col-md-6 logo-lg"
                style="display:flex; justify-content:center;"
              >
                <img
                  id="stamp-img-id"
                  :src="!projectStampUrl ? img_url.img_other_no_picture_available : projectStampUrl"
                  class="resize-img-lg stamp-img-class"
                />
                <!--  -->
                <input
                  id="upload-stamp-img"
                  type="file"
                  accept="image/*"
                  @change="onSelectImg">
              </div>
              <div class="col-xs-8 col-md-6">
                <div>
                  <strong>{{ $t("newproject.projectStamp") }}</strong>
                </div>
                <button v-if="projectStampUrl === null" @click="onUploadStampImg" style="width:100px;">
                  Upload
                </button>
                <button v-else @click="projectStampUrl = null" class="btn btn-danger" style="width:100px;">
                  <i class="fa fa-trash"></i>
                  {{ $t('common.delete') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- chon module -->
        <!-- <div
          class="box box-primary"
          style="display:flex; margin-top: 3rem; font-size: 15pt;"
        >
          <div
            class="col-xs-5"
            style="display:flex; align-items: center; flex-direction: column;"
          >
            <div>{{ $t("newproject.choose_module_options") }}</div>

            <div
              style="height: 100%;padding: 2rem; border: 1px solid; width: 100%;"
            >
              <div v-for="(module, idx) in allmodule" :key="idx">
                <div
                  @click="moduleAvailable(module.id, idx)"
                  :class="
                    module.selected ? 'active module_hover' : 'module_hover'
                  "
                >
                  {{ module.module_name }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-xs-2"
            style="display:flex; align-items: center; justify-content: center;flex-direction: column;"
          >
            <button style="width:9rem;" @click="moveToRightModules">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
            <button
              style="margin-top:3rem;width: 9rem;"
              @click="moveToLeftModules"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
          </div>
          <div
            class="col-xs-5"
            style="display:flex; align-items: center; flex-direction: column;"
          >
            <div>{{ $t("newproject.choosed_modules") }}</div>
            <div
              style="height: 100%;padding: 2rem; border: 1px solid; width: 100%;"
            >
              <div v-for="(module, idx) in purposeModules" :key="idx">
                <div
                  @click="modulePurpose(module.id, idx)"
                  :class="
                    module.selected ? 'active module_hover' : 'module_hover'
                  "
                >
                  {{ module.module_name }}
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div
          class="row"
          style="display:flex; margin-top: 3rem; font-size: 15pt;"
        >
          <div
            class="col-xs-6"
            style="display:flex; align-items: center; flex-direction: column;"
          >
            <div>{{ $t("newproject.choose_module_options") }}</div>

            <div
              style="height: 400px;padding: 2rem; border: 1px solid; width: 100%; "
            >
              <!-- <div v-for="(module, idx) in allmodule" :key="idx">
                  <div
                    @click="moduleAvailable(module.id, idx)"
                    :class="
                      module.selected ? 'active module_hover' : 'module_hover'
                    "
                  >
                    {{ module.module_name }}
                  </div>
                </div> -->
              <select
                multiple="multiple"
                id="lstBox1"
                class="form-control"
                style="height: 100%;"
              >
                <option
                  style=" padding: 8px 10px 8px 10px;  border: 0.5px solid;"
                  @click="moduleAvailable(module.id, idx)"
                  v-for="(module, idx) in allmodule"
                  :key="idx"
                >
                  {{ module.module_name }}</option
                >
              </select>
            </div>
          </div>
          <div
            class="col-xs-1"
            style="display:flex; align-items: center; justify-content: center;flex-direction: column;"
          >
            <!-- <button style="width:9rem;" @click="moveToRightModules">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
              <button
                style="margin-top:3rem;width: 9rem;"
                @click="moveToLeftModules"
              >
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </button> -->
            <!-- <input
              type="button"
              id="btnAllRight"
              @click="moveAllRightModules"
              value=">>"
              class="btn btn-default"
            /><br /> -->
            <input
              type="button"
              id="btnRight"
              @click="moveToRightModules"
              value=">"
              class="btn btn-default"
              :disabled="GET_ACCOUNT_DATA.id !== 1"
            /><br />
            <input
              type="button"
              id="btnLeft"
              @click="moveToLeftModules"
              value="<"
              class="btn btn-default"
              :disabled="GET_ACCOUNT_DATA.id !== 1"
            /><br />
          </div>
          <div
            class="col-xs-6"
            style="display:flex; align-items: center; flex-direction: column;"
          >
            <div>{{ $t("newproject.choosed_modules") }}</div>
            <div
              style="height: 400px;padding: 2rem; border: 1px solid; width: 100%;"
            >
              <select
                multiple="multiple"
                id="lstBox2"
                class="form-control"
                style="height: 100%;"
              >
                <option
                  style="padding: 8px 10px 8px 10px;  border: 0.5px solid;"
                  @click="modulePurpose(module.id, idx)"
                  v-for="(module, idx) in purposeModules"
                  :key="idx"
                  :style="{ backgroundColor: module.id == 6 || module.id == 7 || module.id == 14 ? 'antiquewhite' : ''}"
                >
                  {{ module.module_name }}</option
                >
              </select>
              <!-- <div v-for="(module, idx) in purposeModules" :key="idx">
                  <div
                    @click="modulePurpose(module.id, idx)"
                    :class="
                      module.selected ? 'active module_hover' : 'module_hover'
                    "
                  >
                    {{ module.module_name }}
                  </div>
                </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_project_setting')"
          @click="showOnSaveProjectGeneralInfo()"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
    <div class="modal fade" id="modal-projectGeneralSetting">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("ProjectGeneralSettings.project_seting_title") }}
            </h4>
          </div>
          <div class="modal-body">
            {{ $t("ProjectGeneralSettings.project_seting_msg") }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              v-if="GET_ACCOUNT_DATA.group_id == 1"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              v-if="GET_ACCOUNT_DATA.group_id == 1"
              class="btn btn-primary btn-green"
              @click="onSaveProjectGeneralInfo"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <input
      type="file"
      ref="upload_logo"
      accept="image/*"
      style="display:none"
      @change="onHandleUploadLogo"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import constantsData from "@/lib/constantsData";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils, { uploadFileToMediaAgent } from "@/lib/utils";
import Logo from "@/components/Logo/LogoCrop.vue";
import configuration from "@/lib/config";
import ProjectStatusEnum from "@/enum/projectStatusEnum";

export default {
  name: "ProjectGeneralSettings",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      project_name: "",
      project_id: "",
      project_code: "",
      project_owner: "",
      project_start_date: "",
      operator_name: "",
      operator_telephone: "",
      operator_website: "",
      adminEmail: null,
      companyName: null,
      taxIdentificationNumber: null,
      customerCarePhoneNumber: null,
      managingDirector: null,
      operator_address: "",
      project_description: "",
      project_date_format: "",
      project_status: ProjectStatusEnum.ACTIVE,
      project_status_list: constantsData.projectStatusType,
      project_logo: null,
      projectStampUrl: null,
      projectStampFile: {
        imageFile: null
      },
      isLoading: false,
      uploadFile: null,
      allmoduleIndexSelectedList: [],
      purposeModuleIds: [],
      purposeModulesIndexSelectedList: [],
      allmodule: [],
      purposeModules: [
        {
          module_name: this.$t("sidebar.decentralizationManagement.title"),
          id: 7,
          selected: false,
          isNotChange: true
        },
        {
          module_name: this.$t("sidebar.projectsettings.title"),
          id: 6,
          selected: false,
          isNotChange: true
        },
        {
          module_name: this.$t("sidebar.documentation"),
          id: 14,
          selected: false,
          isNotChange: true
        }
      ],
    };
  },
  watch: {
    item: function() {
      this.initialize();
    },
    GET_LANG: function() {
      this.initialize();
    },
    GET_PROJECT_MODULE_DATA: function() {
      let project_module = this.GET_PROJECT_MODULE_DATA;
      this.purposeModuleIds = [];
      this.purposeModules = [
        {
          module_name: this.$t("sidebar.decentralizationManagement.title"),
          id: 7,
          selected: false,
          isNotChange: true
        },
        {
          module_name: this.$t("sidebar.projectsettings.title"),
          id: 6,
          selected: false,
          isNotChange: true
        },
        {
          module_name: this.$t("sidebar.documentation"),
          id: 14,
          selected: false,
          isNotChange: true
        }
      ];
      project_module.forEach(module => {
        if (module.module != 6 && module.module != 7 && module.module != 14) {
          let data = {
            module_name: this.$t(
              "sidebar.decentralizationManagement.modules." + module.module_name
            ),
            id: module.module,
            selected: false,
            isNotChange: false
          };
          this.purposeModules.push(data);
          this.purposeModuleIds.push(data.id);
        }
      });
    },
    GET_ALL_MODULES_PROJECT_DATA: function() {
      this.purposeModuleIds.push(6, 7, 14);
      this.allmodule = [];
      this.GET_ALL_MODULES_PROJECT_DATA.forEach(module => {
        if (this.purposeModuleIds.indexOf(module.id) == -1) {
          let data = {
            module_name: this.$t(
              "sidebar.decentralizationManagement.modules." + module.module_name
            ),
            id: module.id,
            selected: false
          };
          this.allmodule.push(data);
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_LANG",
      "GET_ACCOUNT_DATA",
      "GET_ALL_MODULES_PROJECT_DATA",
      "GET_PROJECT_MODULE_DATA",
    ])
  },
  methods: {
    ...mapActions([
      "UPDATE_PROJECT",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_ALL_MODULES_PROJECT",
      "GET_PROJECT_LIST",
      "GET_PROJECT_MODULE",
    ]),
    triggerInputUploadLogo: function() {
      this.$refs.upload_logo.click();
    },
    onHandleUploadLogo: function() {
      let file = this.$refs.upload_logo.files[0];
      if (file.size > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("ProjectGeneralSettings.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.uploadFile = file;
        this.$refs.logoCrop.inputFile(file);
      }
    },
    GetProjectLogo: function(data) {
      this.project_logo = data;
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    initialize: function() {
      this.project_name = this.item.project_name;
      this.project_id = this.item.project_id;
      this.project_code = this.item.project_code;
      this.project_logo = this.item.project_logo;
      this.project_owner = this.item.project_owner;
      this.project_start_date = utils.formatSqlDate(this.item.project_start_date, "DD/MM/YYYY", "DD/MM/YYYY");
      this.project_status = this.item.project_status;
      this.operator_name = this.item.operator_name;
      this.operator_telephone = this.item.operator_telephone;
      this.operator_website = this.item.operator_website;
      this.operator_address = this.item.operator_address;
      this.project_description = this.item.project_description;
      this.adminEmail = this.item.admin_email
      this.managingDirector = this.item.managing_director
      this.customerCarePhoneNumber = this.item.customer_care_phone_number
      this.companyName = this.item.company_name
      this.taxIdentificationNumber = this.item.tax_identification_number
      this.projectStampUrl = this.item.project_stamp
    },
    showOnSaveProjectGeneralInfo() {
      $("#modal-projectGeneralSetting").modal("show");
    },
    // moveAllRightModules: function(e) {
    //   let selectedOpts = $("#lstBox1 option");
    //   if (selectedOpts.length == 0) {
    //     alert("Nothing to move.");
    //     e.preventDefault();
    //   }
    //   $("#lstBox2").append($(selectedOpts).clone());
    //   $(selectedOpts).remove();
    //   e.preventDefault();
    // },
    moveToRightModules: function(e) {
      let selectedOpts = $("#lstBox1 option:selected");
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        e.preventDefault();
      }
      for (
        let j = 0, sizeA = this.allmoduleIndexSelectedList.length;
        j < sizeA;
        j++
      ) {
        for (let i = 0, size = this.allmodule.length; i < size; i++) {
          if (this.allmoduleIndexSelectedList[j] == this.allmodule[i].id) {
            this.allmodule[i].selected = false;
            this.purposeModules.push(this.allmodule[i]);
            this.allmodule.splice(i, 1);
            break;
          }
        }
      }
      this.allmoduleIndexSelectedList = [];
    },
    moveToLeftModules: function(e) {
      let selectedOpts = $("#lstBox2 option:selected");
      if (selectedOpts.length == 0) {
        alert("Nothing to move.");
        e.preventDefault();
      }
      for (
        let j = 0, sizeA = this.purposeModulesIndexSelectedList.length;
        j < sizeA;
        j++
      ) {
        for (let i = 0, size = this.purposeModules.length; i < size; i++) {
          if (
            this.purposeModulesIndexSelectedList[j] ==
              this.purposeModules[i].id &&
            !this.purposeModules[i].isNotChange
          ) {
            this.purposeModules[i].selected = false;
            this.allmodule.push(this.purposeModules[i]);
            this.purposeModules.splice(i, 1);
            break;
          }
        }
      }
      this.purposeModulesIndexSelectedList = [];
    },
    modulePurpose: function(id, idx) {
      let array = this.purposeModules;
      array[idx].selected = !array[idx].selected;
      if (this.purposeModulesIndexSelectedList.indexOf(id) == -1) {
        this.purposeModulesIndexSelectedList.push(id);
      } else {
        this.purposeModulesIndexSelectedList = this.purposeModulesIndexSelectedList.filter(
          moduleId => {
            return moduleId != id;
          }
        );
      }
    },
    moduleAvailable: function(id, idx) {
      let array = this.allmodule;
      array[idx].selected = !array[idx].selected;
      if (this.allmoduleIndexSelectedList.indexOf(id) == -1) {
        this.allmoduleIndexSelectedList.push(id);
      } else {
        this.allmoduleIndexSelectedList = this.allmoduleIndexSelectedList.filter(
          moduleId => {
            return moduleId != id;
          }
        );
      }
    },
    onSaveProjectGeneralInfo: function() {
      $("#modal-projectGeneralSetting").modal("hide");
      this.waitingLoading(true);
      let module_ids = [];
      this.purposeModules.forEach(el => {
        module_ids.push(el.id);
      });
      let filter = {
        data: {
          id: this.item.project_id,
          project_name: this.project_name,
          project_code: this.project_code,
          project_owner: this.project_owner,
          project_logo: this.project_logo,
          project_start_date: utils.formatSqlDate(this.project_start_date, "DD/MM/YYYY", "YYYY-MM-DD[T]HH:mm:ss"),
          project_status: this.project_status,
          operator_name: this.operator_name,
          operator_telephone: this.operator_telephone,
          operator_website: this.operator_website,
          operator_address: this.operator_address,
          project_description: this.project_description,
          admin_email: this.adminEmail,
          managing_director: this.managingDirector,
          customer_care_phone_number: this.customerCarePhoneNumber,
          company_name: this.companyName,
          tax_identification_number: this.taxIdentificationNumber,
          project_stamp: this.projectStampUrl
        },
        moduleIds: module_ids
      };
      this.UPDATE_PROJECT({ id: filter.data.id, data: filter })
        .then(
          function() {
            sessionStorage.setItem('projectLogo', this.project_logo)
            sessionStorage.setItem('projectName', this.project_name)
            sessionStorage.setItem('projectCode', this.project_code)
            this.waitingLoading(false);
            this.SUCCESS_TOAST();
            location.reload();
          }.bind(this)
        )
        .catch(
          function() {
            this.waitingLoading(false);
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    waitingLoading: function(bol) {
      this.isLoading = bol;
    },
    onSelectImg: async function(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.getResultFile(files[0])
      // this.projectStampUrl = URL.createObjectURL(files[0])
      this.projectStampUrl = await uploadFileToMediaAgent(this.projectStampFile.imageFile, 'project/stamp')
    },
    getResultFile: function(file) {
      let vm = this;
      vm.projectStampFile.imageFile = file;
    },
    onUploadStampImg: function() {
      $('#upload-stamp-img').click()
    },
  },
  async mounted() {
    let projectId = utils.getProjectSession()
    this.isLoading = true
    await this.initialize();
    await this.GET_PROJECT_LIST();
    await this.GET_PROJECT_MODULE({ id: projectId });
    await this.GET_ALL_MODULES_PROJECT();
    this.isLoading = false
  },
  components: {
    loading: Loading,
    "lte-core-alert": LTECoreAlert,
    "logo-crop": Logo
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.module_hover:hover {
  cursor: pointer;
  background-color: #b7a5a5;
}
.module_hover.active {
  background-color: #b7a5a5;
}

.resize-img-lg {
  height: auto;
  width: auto;
  max-width: 70px;
  max-height: 70px;
}

input[type="file"] {
  display: none;
}
.stamp-img-class {
  max-height: 60px;
  max-width: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ProjectGeneralSettings.vue